import { FieldEvent, FieldTarget } from '@routellers/types/dist/openapi/city-player/city-field';
import { ApiMethodDeclaration } from '..';
export const fieldHistory: ApiMethodDeclaration<FieldTarget, FieldEvent[]> = ({ kind, id }) => ({
    url: `/admins/field/objects/${kind}/${id}/history`,
    method: 'GET',
});
export const fieldJournal: ApiMethodDeclaration<{ cityId: number }, FieldEvent[]> = ({
    cityId,
}) => ({ url: `/admins/field/journal/${cityId}`, method: 'GET' });
